// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".component-fade-enter-active,.component-fade-leave-active{transition:all 0s ease .15s}.desktop-service-bar .slick-list{margin-left:-100px!important}.desktop-service-bar .slick-slide>div{margin-left:100px}@media only screen and (max-width:1440px){.desktop-service-bar .slick-slide>div{overflow:hidden}}.fullpage-slide{max-width:1440px;width:100%;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
